

// Common JS
// Global Variables
const
    menu = document.querySelector(".menu"),
    menuItems = document.querySelectorAll(".menuItem"),
    hamburger= document.querySelector(".svgsp-bmenu"),
    header = document.querySelector('.header'),
    toggleActionsStds = "restart resume resume reverse";

// Check Page is SUPP or RETAIL
let suppPage = false,
    retPage = false,
    mainPage = false,
    contentPage = false;
if(document.body.classList.contains('supp')){
    suppPage = true;
} else if(document.body.classList.contains('retailer'))  {
    retPage = true;
} else if(document.body.classList.contains('mainPage'))  {
    mainPage = true;
} else if(document.body.classList.contains('contentPage'))  {
    contentPage = true;
}
// VH / VW
// INIT Setting window type (desktop / mobile)
// INIT Setting window orienttation (landscape / portait)
let windowWidth = innerWidth,
    windowHeight = innerHeight,
    windowType = "",
    windowOrientation = "";

if(windowWidth < 767){
    windowType = "Mobile"
} else {
    windowType = "Desktop"
}
if(windowWidth > windowHeight){
    windowOrientation = "Landscape"
} else {
    windowOrientation = "Portrait"
}

// Resizing Check
// onResize Setting window type (desktop / mobile)
// onResize Setting window orienttation (landscape / portait)
window.addEventListener('resize', function(){
    clearTimeout(window.resizedFinished);
    if (innerWidth != windowWidth) {
        window.resizedFinished = setTimeout(function(){
            windowWidth = innerWidth;
            if(windowWidth < 768){
                setWindowType("Mobile");
            } else if(windowWidth >= 768){
                setWindowType("Desktop");
            }
            if(windowWidth > windowHeight){
                setWindowOrientation("Landscape");
            } else if(windowWidth <= windowHeight){
                setWindowOrientation("Portrait");
            }
        }, 250);
    }
});
function setWindowType(value){
    windowType = value;
    changeMobDesktop(windowType);
}
function setWindowOrientation(value){
    windowOrientation = value;
}

// Header Fix
if (!mainPage){
    (function(){
    var doc = document.documentElement;
    var w = window;
    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;
    var checkScroll = function() {
        /*
        ** Find the direction of scroll
        ** 0 - initial, 1 - up, 2 - down
        */

        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll > prevScroll) {
            //scrolled up
            direction = 2;
        }
        else if (curScroll < prevScroll) {
            //scrolled down
            direction = 1;
        }

        if (direction !== prevDirection) {
            toggleHeader(direction, curScroll);
        }
        if (curScroll > 5){
            header.classList.add('interMediate');
        } else if (curScroll < 5){
            header.classList.remove('interMediate');
        }
        prevScroll = curScroll;
    };
    var toggleHeader = function(direction, curScroll) {
        if (direction === 2 && curScroll > 400) {
            header.classList.add('hide');
            prevDirection = direction;
        }
        else if (direction === 1) {
            header.classList.remove('hide');
            prevDirection = direction;
        }
    };

    document.addEventListener('scroll', checkScroll);
})();
}
function initHeaderState(value){
    if (window.scrollY > 5){
        header.classList.add('interMediate');
        setTimeout(function(){
            header.classList.remove('hide');
        }, 1000);
    }
    if (value === "show"){
        setTimeout(function(){
            header.classList.remove('hide');
        }, 1000);
    } else if (value === "remove"){
        setTimeout(function(){
            header.classList.remove('hide');
        }, 1000);
    }

}
// Menu Animation
let menutl;
function menuOpenFunction(){
    menutl = gsap.timeline({paused: true, defaults: {ease: "power4.inOut"}});
    menutl
    .fromTo(menu,
        {display:"none", opacity:0, clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)'},
        {height: "100vh", display:"flex", opacity:1, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', duration: 0.4}, "menuAnimStarted")
    .fromTo(".menu .menuItem",
        {opacity:0, y: 30},
        {opacity:1, y: 0, stagger:0.1, duration:0.5}, "menuAnimStarted+=0.3")
    .fromTo(".menu .menuItem .afterLay",
        {width:"120%"},
        {width:"0%", opacity:1, stagger:0.1, duration:0.5}, "menuAnimStarted+=0.7")
    .fromTo(".hamburger .hamafter",
        {width:20, top:20, backgroundColor: "black", rotation: 0},
        {width:30, top:13,backgroundColor: "white", rotation: 45, duration:0.2}, "menuAnimStarted")
    .fromTo(".hamburger .hambefore",
        {top: 9, backgroundColor: "black", rotation: 0},
        {top: 13,backgroundColor: "white", rotation: 135, duration:0.2}, "menuAnimStarted")
}
// Toggle Menu
function htmlOverflowManager(type = "auto"){
    let htmlDocElement = document.documentElement;
    htmlDocElement.style.overflow = type
}
function toggleMenu() {
    if (menu.classList.contains("active")) {
        htmlOverflowManager("auto")

        menutl.timeScale(2).reverse();
        menu.classList.remove("active");
        hamburger.classList.remove("active");
    } else {
        htmlOverflowManager("hidden")

        menutl.timeScale(2).play();
        menu.classList.add("active");
        hamburger.classList.add("active");
    }
}
function toggleMenuWithItems(){
    // Menu Items Toggle menu and scroll to window
    menuItems.forEach(
        function (menuItem) {
            menuItem.addEventListener("click", function (e) {
                if (menuItem.classList.contains('scroll')){
                    e.preventDefault();
                }
                if (windowType === "Mobile") {
                    toggleMenu();
                }
                let itemIdScrollSection = document.querySelector(this.getAttribute('href'));
                gsap.to(window, {duration: 0, scrollTo: {y: itemIdScrollSection, offsetY: 100, onComplete: initHeaderState, onCompleteParams: ["show"] }});
            });
        }
    );
}

// Main Page Animation
function mainPageAnimation(){
    let homewrapper = document.querySelector(".homeWrapper");
    let wrappers = document.querySelectorAll(".wrapper.main");
    let mainImg = document.querySelectorAll(".mainImage");
    let staggers = document.querySelectorAll(".stagger");
    // let arrowStagger = document.querySelectorAll(".svgsp.svgsp-Arrow");
    let tl = gsap.timeline({
        defaults: {ease: "power4.inOut", duration: 2}
    });
    tl.set(homewrapper, {height:0})
        .set(wrappers, {opacity:0, y:100, scaleY: 0})
        .to(homewrapper, {height:"auto", duration: 1}, "animStart")
        .to(wrappers, {opacity:1, stagger: 0.1, scaleY:1, y: 0}, "animStart")
        .fromTo(mainImg, {y:-150, opacity:0}, {stagger:0.2, y:0, opacity:1}, "animStart+=0.5")
        .fromTo(staggers, {opacity:0, y:50}, {stagger:0.1, opacity:1, y:0}, "animStart+=0.4")
}
// Retail Specific Animation
function howToSignUpSliderBlocks(opacityAfter, scaleMid, colorMid, colorFinal){
    function clearProps(){
        gsap.set(".hero__device--anim, .scm-abs", {clearProps: "all" }),
        gsap.set(".slidertop, .wrapIMGS", {clearProps: "all" }),
        gsap.set(".text1, .text2, .text3, .text4", {clearProps: "all" }),
        gsap.set(".scm-img1,.scm-img2,.scm-img3,.scm-img4", {clearProps: "all" })
    }
    ScrollTrigger.matchMedia({
        // desktop
        "(max-width: 767px)": function() {
            clearProps();
            let timelineThis = gsap.timeline({
                scrollTrigger:{
                    trigger: ".hero__device--anim",
                    pin: true,
                    // markers: true,
                    scrub: 1,
                    start: "top top",
                    end: "+=120% center",
                    pinSpacing: true,
                    // markers: {startColor: "green" , endColor: "red" , fontSize: "12px"},
                    toggleActions: toggleActionsStds
                },
                defaults: {ease: Linear.easeNone}
            });
            timelineThis.fromTo(".scm-abs, .heroSpaceHolder", 0.5, {width: '90%'}, {width: '70%', ease: Linear.easeNone}, "animStart")
                .to(".slidertop", 0.25, {paddingTop: "5vh"}, 'animStart')
                .to(".text1", 0.25, {opacity: 1,scale:scaleMid, color:colorMid}, '-=0.25')
                .fromTo(".scm-img2", 0.25, {opacity:0}, {opacity:1, ease: Quint.easeOut}, '+=0.7')
                .to(".text1", 0.25, {opacity: opacityAfter,scale:1, color:colorFinal}, '-=0.25')
                .to(".text2", 0.25, {opacity: 1,scale:scaleMid, color:colorMid}, '-=0.25')
                .fromTo(".scm-img3", 0.25, {opacity:0}, {opacity:1, ease: Linear.easeNone}, '+=0.7')
                .to(".text2", 0.25, {opacity: opacityAfter, scale:1, color:colorFinal}, '-=0.25')
                .to(".text3", 0.25, {opacity: 1, scale:scaleMid, color:colorMid}, '-=0.25')
                .fromTo(".scm-img4", 0.25, {opacity:0}, {opacity:1, ease: Linear.easeNone}, '+=0.7')
                .to(".text3", 0.25, {opacity: opacityAfter, scale:1, color:colorFinal}, '-=0.25')
                .to(".text4", 0.25, {opacity: 1, scale:scaleMid,color:colorMid}, '-=0.25')
                .to(".text4", 0.25, {opacity: opacityAfter, scale:1,color:colorFinal}, '+=0.7');
        },

        "(min-width: 768px)": function() {
            clearProps();
            let endtime = "+=200% center"; // to sync the header fix with the animation
            let timelineThis3 = gsap.timeline({
                scrollTrigger:{
                    trigger: ".hero__device--anim",
                        pin: ".headerDK",
                        scrub: 1,
                        start: "top top",
                        end: endtime,
                        pinSpacing: true,
                },
                defaults: {ease: Linear.easeNone, duration: 0.1}
            })
            let subtitleOnSignup = document.querySelectorAll('.subtitleOnSignup')
            let timelineThis = gsap.timeline({
                scrollTrigger:{
                    trigger: ".hero__device--anim",
                        pin: true,
                        // markers: true,
                        scrub: 1,
                        start: "top top",
                        end: endtime,
                        pinSpacing: true,
                        // markers: {startColor: "green" , endColor: "red" , fontSize: "12px"},
                        toggleActions: toggleActionsStds
                },
                defaults: {ease: Linear.easeNone, duration: 0.1}
            })

            timelineThis
                .fromTo(".slidertop", {width:0}, {width:"100%", duration: 2}, "animSTART")
                .to(".wrapIMGS", {width:"auto", margin:"0 -5vw", duration: 2, scale:0.8}, "animSTART")
                .fromTo(subtitleOnSignup, {opacity:0, y:-20}, {opacity:1, y:0, stagger: 1, duration: 1}, "animSTART+=2")
                .set({}, {}, "+=2")
        }

    });

}

// Supplier Specific Animation
// Mobile for Retail ANIMATION
function mobileForSupplierBlock(value){

    ScrollTrigger.matchMedia({
        "(max-width: 767px)": function() {
            let tl = gsap.timeline({
                scrollTrigger:{
                    trigger: ".hero__device__animsupp",
                    start: "center 50%",
                    scrub:1,
                    end: "bottom center",
                    // markers: {startColor: "green" , endColor: "red" , fontSize: "12px"},
                    toggleActions: toggleActionsStds
                },
                defaults: {duration: 2}
            });
            tl.fromTo(".scalerSupp",
                {scale: 1},
                {scale: 0.55, transformOrigin: "top center"})
        },

        "(min-width: 768px)": function() {
            let tl = gsap.timeline({
                scrollTrigger:{
                    trigger: ".hero__device__animsupp",
                    start: "top 40%",
                    scrub:1,
                    end: "bottom 90%",
                    // markers: {startColor: "green" , endColor: "red" , fontSize: "12px"},
                    toggleActions: toggleActionsStds
                },
                defaults: {duration: 2}
            });
            tl.fromTo(".scalerSupp",
                {scale: 1},
                {scale: 0.8, transformOrigin: "center center"}, "animStart")
                .to(".secondarySupp", {scale: 0.6,transformOrigin: "center center"}, "animStart+=0.2")
                .to(".secondaryLeft", {"left":"30%",transformOrigin: "center center"}, "animStart+=0.2")
                .to(".secondaryRight", {"right":"30%",transformOrigin: "center center"}, "animStart+=0.2")
        }
    });
}
// SUPPLIER STEP 1 ANIMATION
function suppStep1Block(startPoint, value){
    let parent = document.querySelector(".how-to-use__step--1");
    let number = parent.querySelector(".how-to-use__step__number");
    let title = parent.querySelector(".how-to-use__step__title");
    let desc = parent.querySelector(".how-to-use__step__description");
    let extraDesc1 = parent.querySelector(".extraDesc1");
    let extraDesc2 = parent.querySelector(".extraDesc2");
    let tl = gsap.timeline({
        scrollTrigger:{
            trigger: parent,
            start: startPoint,
            // markers: {startColor: "green" , endColor: "red" , fontSize: "12px"},
            toggleActions: toggleActionsStds
        },
        defaults: {ease: "power4.inOut"}
    });
    tl.from(number, {y:50, opacity:0, duration: 0.5})
        .fromTo('.supstep2__1__img1 .f',
            {scale:0,transformOrigin: "center center"},
            {scale:1,transformOrigin: "center center", ease: Linear.easeNone, duration:0.3, stagger:0.05}, "startAnim")
        .fromTo('.supstep2__1__img1 .f2',
            {scale:0,transformOrigin: "center top"},
            {scale:1,transformOrigin: "center top", duration:0.2}, "startAnim+=1")
        .from(title, {y:50, opacity:0, duration: 1}, "startAnim+=0.4")
        .from(desc, {y:50, opacity:0, duration:  1}, "startAnim+=0.5")
        .from(extraDesc1, {y:50, opacity:0, duration:  1}, "startAnim+=0.6")
        .from(extraDesc2, {y:50, opacity:0, duration:  1}, "startAnim+=0.7")
}
// SUPPLIER STEP 2 ANIMATION
function suppStep2Block(startPoint, value){
    let parent = document.querySelector(".how-to-use__step--2");
    let number = parent.querySelector(".how-to-use__step__number");

    let tl = gsap.timeline({
        scrollTrigger:{
            trigger: number,
            start: startPoint,
            // markers: {startColor: "green" , endColor: "red" , fontSize: "12px"},
            toggleActions: toggleActionsStds
        },
        defaults: {ease: "power4.inOut"}
    });
    tl.fromTo('.supstep__1__perspective',
        {opacity:0,scale: 1,z: 0,transformPerspective: 2000,rotationX: 0},
        {opacity:1,scale: 1.1,z: 30,transformPerspective: 2000,rotationX: 40, duration:1}, "startAnim")
        .fromTo('.supstep__1__img2', {opacity:0, z: -30}, {stagger:0.1,opacity:1, z: 0, duration:1}, "startAnim+=0.9")
}
// SUPPLIER STEP 3 ANIMATION
function suppStep3Block(startPoint, value){
    let parent = document.querySelector(".how-to-use__step--3");
    let number = parent.querySelector(".how-to-use__step__number");
    let title = parent.querySelector(".how-to-use__step__title");
    let desc = parent.querySelector(".how-to-use__step__description");

    let tl = gsap.timeline({
        scrollTrigger:{
            trigger: parent,
            start: startPoint,
            // markers: {startColor: "green" , endColor: "red" , fontSize: "12px"},
            toggleActions: toggleActionsStds
        },
        defaults: {ease: "power4.inOut"}
    });
    tl.from(number, {y:50, opacity:0, duration: 0.5})
        .fromTo('.supstep3__1__img1 #lptp',
            {opacity:0, y:"27%"},
            {opacity:1, y:"11%", duration:1.5}, "startAnim")
        .fromTo('.supstep3__1__img1 .feat',
            {opacity:0,rotation:180,transformOrigin: "center center"},
            {opacity:1,rotation:0,transformOrigin: "center center", stagger:0.2, duration:1}, "startAnim+=1")
        .from(title, {y:50, opacity:0, duration: 1}, "startAnim+=0.4")
        .from(desc, {y:50, opacity:0, duration: 1}, "startAnim+=0.5")
}


// Supplier and Retail Specific Animation
const
    features = document.querySelectorAll(".features__item"),
    appProvides = document.querySelectorAll(".app-provides__item"),
    fadeIns = document.querySelectorAll('.fade-in'),
    fadeInHowToUse = document.querySelectorAll('.fadeInHowToUse'),
    contactForm = document.querySelectorAll('.contact__form__area');
    // arrowsSeperators = document.querySelectorAll('.how-to-use__arrow-seperator .svgsp');

// Intro
function introAnimation(value) {
    if (suppPage){
        var heroImgIntro = ".hero__device .heroDeviceFadeIn"
    } else if (retPage) {
        if (windowType === "Desktop"){
            var heroImgIntro = ".hero__device .scm-abs"
        } else if (windowType === "Mobile"){
            var heroImgIntro = ".hero__device .scm-img1"
        }
    }
    ScrollTrigger.matchMedia({
        "(max-width: 767px)": function() {
            let tl = gsap.timeline({
                defaults: {ease: "power4.inOut", duration: 2}
            });
            tl.set(".cta__deco img", {opacity: 0})
                .to('.header', {opacity:1, duration:0.6,ease: Linear.easeNone})
                .to('.header .svgsp', {stagger: 0.2, opacity:1, y: 0, duration:0.6,ease: Linear.easeNone},"animStart")
                .to('.hero h1, .hero p', {stagger: 0.1, opacity:1, y: 0}, "animStart+=0.4")
                .to('.hero__cta span, .hero__cta .svgsp', {stagger: 0.1, opacity:1, y: 0}, "animStart+=0.8")
                .fromTo(heroImgIntro, {opacity:1, clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)', y:100}, {clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', y: 0}, "animStart+=1")
                .fromTo('.cta__deco img', {opacity:0,scale: 1, width: "300%"}, {opacity:0.7,scale: 1,width: "60%" ,duration:2},"animStart+=1.4")
        },

        "(min-width: 768px)": function() {
            let tl = gsap.timeline({
                defaults: {ease: "power4.inOut", duration: 2}
            });
            tl.set(".cta__deco img", {opacity: 0})
                .to('.header', {opacity:1, duration:0.6,ease: Linear.easeNone},"animStart")
                .to('.header .svgsp', {stagger: 0.2, opacity:1, y: 0, duration:0.6,ease: Linear.easeNone},"animStart")
                .to('.hero h1, .hero p', {stagger: 0.1, opacity:1, y: 0}, "animStart+=0.4")
                .to('.hero__cta span, .hero__cta .svgsp', {stagger: 0.1, opacity:1, y: 0}, "animStart+=0.8")
                .fromTo(heroImgIntro, {opacity:1, clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)', y:100}, {clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',y: 0}, "animStart+=1")
                .fromTo('.cta__deco img', {opacity:0,scale: 3, width: "300%"}, {opacity:0.7,scale: 1,width: "60%" ,duration:2},"animStart+=1.4")

        }
    });
}

function stepsFinalBlock(value){
    // Checkmark final step
    const start = "M118 0V0";
    const end = "M118 0V112.636";
    let parent = document.querySelector(".how-to-use__step--final");
    let title = parent.querySelector(".how-to-use__step__title");
    let desc = parent.querySelector(".how-to-use__step__description");
    let tl = gsap.timeline({
        scrollTrigger:{
            trigger: parent,
            start: "top 85%",
            // markers: {startColor: "green" , endColor: "red" , fontSize: "12px"},
            toggleActions: toggleActionsStds
        },
        defaults: {ease: "power4.inOut"}
    });
    tl.fromTo(".how-to-use__step__img .line", {attr: { d: start }}, {attr: { d: end }, duration: 0.2}, "startAnim")
        .fromTo(".how-to-use__step__img .maincircle", {scale:0,transformOrigin: "center center"}, {scale:1,transformOrigin: "center center", duration: 0.8}, "-=0.5")
        .fromTo(".how-to-use__step__img .checkmark",
            {opacity:0,scale:0,transformOrigin: "center center"},
            {opacity:1,scale:1,transformOrigin: "center center", duration: 1,ease: "elastic.out(1, 0.3)"}, "feature")
        .from(".how-to-use__step__img .circlee",
            {attr:{r:20}, opacity:0, duration: 0.5, stagger: 0.05}, "feature-=0.7")
        .from(title, {y:50, opacity:0, duration: 1}, "startAnim+=0.4")
        .from(desc, {y:50, opacity:0, duration:  1}, "startAnim+=0.5")

}
function featuresBlocks(value){
    features.forEach((feature) => {
        const
            featureIcon = feature.querySelector('.features__item__icon'),
            featureText = feature.querySelector('.features__item__description'),
            str = featureText.innerText,
            words = str.split(" ");

        var newText = "";

        for (let i = 0; i < words.length; i++) {
            newText += "<span>";
            newText += words[i];
            // newText += "&nbsp;";
            newText += "</span>";
        }
        featureText.innerHTML = newText;
        var targetsDiv = featureText.querySelectorAll("span");
        let tl = gsap.timeline({
            scrollTrigger:{
                trigger: feature,
                start: "top 90%",
                // scrub: 2,
                // end:"bottom 80%",
                // markers: {startColor: "grey" , endColor: "yellow" , fontSize: "12px"},
                toggleActions: toggleActionsStds
            },
            defaults: {ease: "power4.inOut"}
        });
        tl
            .to(feature, {opacity: 1, duration: 0})
            .from(featureIcon, {y:-10, opacity: 0, duration: 1})
            .to(targetsDiv, {stagger: 0.03,opacity:1, y:0, duration: 1}, "-=1");

    });
}
function appProvidesBlocks(value){
    appProvides.forEach((item) => {
        const
            itemIcon = item.querySelector('.app-provides__item__icon'),
            itemText = item.querySelector('.app-provides__item__description');

        let tl = gsap.timeline({
            scrollTrigger:{
                trigger: item,
                start: "top 90%",
                // scrub: 0.1,
                // markers: {startColor: "red" , endColor: "blue" , fontSize: "12px"},
                toggleActions: toggleActionsStds
            },
            defaults: {ease: "power4.inOut"}
        });
        tl.from(item, {scaleX:0, transformOrigin:'right center', opacity: 0, duration: 0.7}, "item")
            .from(itemIcon, {y:16, transformOrigin:'right center', opacity: 0, duration: 0.2}, "item+=0.5")
            .from(itemText, {y:16, transformOrigin:'right center', opacity: 0, duration: 0.2}, "item+=0.5")
    });
}
function fadeInsBlocks(value){
    fadeIns.forEach((item) => {
        let tl = gsap.timeline({
            scrollTrigger:{
                trigger: item,
                start: "top 95%",
                // markers: {startColor: "grey" , endColor: "yellow" , fontSize: "12px"},
                toggleActions: toggleActionsStds
            },
            defaults: {ease: "power4.inOut"}
        });
        tl.fromTo(item, {y:50, opacity:0}, {y:0, opacity: 1, duration: 1})
    });
}
function fadeInHowToUseBlocks(value){
    fadeInHowToUse.forEach((item) => {
        let number = item.querySelector(".how-to-use__step__number");
        let img = item.querySelector(".how-to-use__step__img img");
        // let imgBg = item.querySelector(".how-to-use__step__img--bg");
        let title = item.querySelector(".how-to-use__step__title");
        let desc = item.querySelector(".how-to-use__step__description");
        let decorationCircle1 = item.querySelector(".decorations .circle1");
        let decorationCircle2 = item.querySelector(".decorations .circle2");

        let tl = gsap.timeline({
            scrollTrigger:{
                trigger: item,
                start: "top 90%",
                // markers: {startColor: "grey" , endColor: "yellow" , fontSize: "12px"},
                toggleActions: toggleActionsStds
            },
            defaults: {ease: "power4.inOut"}
        });
        tl
            .from(number, {y:50, opacity:0, duration: 0.5})
            .from(img, {y:100, opacity:0, duration: 1},"animStart")
            // .from(imgBg, {scale:0, opacity:0, duration: 1},"animStart+=0.2")
            .from(title, {y:50, opacity:0, duration: 1}, "animStart+=0.4")
            .from(desc, {y:50, opacity:0, duration: 1}, "animStart+=0.5")
            .from(decorationCircle1, {scale:0, duration: 1}, "animStart+=0.5")
            .from(decorationCircle2, {scale:0, duration: 1}, "animStart+=0.5")
    });
}
// FAQ Toggle
function faqToggle(value) {
    var acc = document.querySelectorAll('.listfaq-content h6');
    var panel = document.querySelectorAll('.listfaq-content p');
    for (var i = 0; i < acc.length; i++) {
        acc[i].onclick = function() {
            var setClasses = !this.classList.contains('active');
            setClass(acc, 'active', 'remove');
            setClass(panel, 'show', 'remove');

            if (setClasses) {
                this.classList.toggle("active");
                this.nextElementSibling.classList.toggle("show");
            }
        }
    }
    function setClass(els, className, fnName) {
        for (var i = 0; i < els.length; i++) {
            els[i].classList[fnName](className);
        }
    }
}
// Contact Form
function contactFormBlocks(value){
    contactForm.forEach((item) => {
        const
            itemInput = item.querySelector('.contactfader'),
            contactFormController = new ScrollMagic.Controller(),
            contactFormTimeline = new TimelineMax()
                .from(item, 0.8, {scaleX:0, transformOrigin:'right center', opacity: 0, ease: Linear.easeNone})
                .from(itemInput, 0.8, {opacity:0, y:16, ease: Linear.easeNone}, "+=0.8");
        // create scene and animation
        new ScrollMagic.Scene({
            triggerElement: item,
            triggerHook: 0.9,
            duration: 50,
        })
            .setTween(contactFormTimeline)
            .addTo(contactFormController)
    });
}
// Swiper
function swiperBlock(){
    const swiperSupplier = new Swiper('.suppliers__swiper', {
        slidesPerView: "auto",
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
        },
        // pagination: {
        //     el: '.swiper-pagination-supplier',
        //     clickable: true,
        // },
        // pagination: false,
        // navigation: false,
        // navigation: {
        //     prevEl: ".swiper-button-next",
        //     nextEl: ".swiper-button-prev",
        // },
        freeMode: true,
        // speed: 5000,
        freeModeMomentum: false
    });
}

// document initiation
// Responsive grouping of functions
function menuToggleResponsive() {
    toggleMenuWithItems();
    if (windowType === "Mobile") {
        menu.classList.remove('desktopMenu');
        menuOpenFunction();
        hamburger.addEventListener("click", toggleMenu);
    } else if (windowType === "Desktop"){
        gsap.set(menu, {clearProps: "all" })
        gsap.set(".menuItem", {clearProps: "all" })
        menu.classList.add('desktopMenu');
    }
}
// function retailHeroResponsive() {
//     if (windowType === "Mobile") {
//
//     } else if (windowType === "Desktop"){
//         gsap.set(menu, {clearProps: "all" })
//         gsap.set(".menuItem", {clearProps: "all" })
//     }
// }

// Retail top animation


if(mainPage){
    document.addEventListener("DOMContentLoaded", function(event) {
        let loader = document.querySelector(".loading");
        loader.style.opacity = 0;
        window.setTimeout(function(){
            loader.style.height = '0';
        },700); // timed to match animation-duration
        mainPageAnimation();
    })
} else {
    if(retPage){
        howToSignUpSliderBlocks(0.2, 1.2, "#00A98F", "#1d1d1f");
        swiperBlock();
    }
    if (!mainPage ){
        initHeaderState();
        menuToggleResponsive();
        introAnimation();
    }
    if(suppPage){
        let resizerStartPoint = {desktop:   "top 90%", mobile: "bottom 90%"};
        // console.log(resizerStartPoint);
        // console.log(resizerStartPoint.desktop);
        // Start point animation for supplier features
        let startPoint = "top 90%";
        mobileForSupplierBlock(startPoint);
        suppStep1Block(startPoint);
        suppStep2Block(startPoint);
        suppStep3Block(startPoint);
    };
    if(suppPage || retPage){
        stepsFinalBlock();
        faqToggle();
        featuresBlocks();
        appProvidesBlocks();
    }
    fadeInsBlocks();
    fadeInHowToUseBlocks();
    contactFormBlocks();
}


function changeMobDesktop(value){
    clearTimeout(window.changeResponsiveTimeOut);
    window.changeResponsiveTimeOut = setTimeout(function(){
        menuToggleResponsive();
        if(retPage){
            howToSignUpSliderBlocks(0.2, 1.2, "#00A98F", "#1d1d1f");
        };
    }, 250);
}




// Check if NOT Touch device
if(!window.matchMedia("(pointer: coarse)").matches) {
    // TILT!
    // VanillaTilt.init(document.querySelectorAll(".js-tilt"));
}


// const sectionTrigger = document.querySelector(".triggerrR2");
// if (sectionTrigger){
//     const sections = gsap.utils.toArray(".rR2");
//     let maxWidth = 0;

//     const getMaxWidth = () => {
//         maxWidth = 0;
//         sections.forEach((section) => {
//             maxWidth += section.offsetWidth;
//         });
//     };
//     getMaxWidth();
//     ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

//     gsap.to(sections, {
//         x: () => `-${maxWidth - window.innerWidth + 60}`,
//         ease: "none",
//         scrollTrigger: {
//             trigger: ".triggerrR2",
//             // pinSpacing: true,
//             pin: ".innerPages",
//             scrub: true,
//             end: () => `+=${maxWidth}`,
//             start: "top 20%",
//             invalidateOnRefresh: true
//         }
//     });

//     sections.forEach((sct, i) => {
//         ScrollTrigger.create({
//             trigger: sct,
//             start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/4) * (maxWidth / (maxWidth - window.innerWidth)),
//             end: () => '+=' + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
//             toggleClass: {targets: sct, className: "active"}
//         });
//     });
// }

if (document.querySelector('.teamMembers')){

    let teamMembers         =  document.querySelectorAll('.teamMember'),
        teamMembersArr      =  [...teamMembers],
        modal               =  document.querySelector('.modal'),
        modalText           =  modal.querySelector('.name'),
        modalNext           =  modal.querySelector('.nextModal'),
        modalPrev           =  modal.querySelector('.prevModal'),
        modalImg            =  modal.querySelector('.img img'),
        modalTitle          =  modal.querySelector('.title'),
        modalDescription    =  modal.querySelector('.description'),
        modalClose          =  modal.querySelector('.closeModal'),
        groupAnimationBlocks = [modalText, modalTitle, modalDescription],
        groupControls = [modalNext, modalClose, modalPrev];

    let teamMembersLoading = gsap.timeline({defaults: {ease: "power4.inOut"}});
    teamMembersLoading.to(teamMembers, {opacity:1, y:0, duration:1, stagger:0.1, delay:0.6})

    let modalBlockOpen = gsap.timeline({paused: true, defaults: {ease: "power4.inOut"}});
    modalBlockOpen.to(modal, {"padding":"20px","border":"20px solid #005c5d","border-radius": 0, "width": "100%", "height": "100%", top:0, right:0, duration:0.5})
    modalBlockOpen.to(groupControls, {opacity:1, y:0, duration:0.2, stagger:0.1})
    
    let modalOpenTimeline = gsap.timeline({paused: true, defaults: {ease: "power4.inOut"}});
    modalOpenTimeline.to(modalImg, {x:0, duration:0.5, clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"}, "animStart")
    modalOpenTimeline.to(groupAnimationBlocks, {opacity:1, y:0, duration:0.5, stagger:0.1}, "animStart-=0.2")

    function playTimeline(){
        return modalOpenTimeline.timeScale(0.7).play()
    }
    function reverseTimeline(){
        return modalOpenTimeline.timeScale(5).reverse()
    }

    function playOpenModalContainer(){
        return modalBlockOpen.timeScale(0.7).play()
    }

    function reverseOpenModalContainer(){
        return modalBlockOpen.timeScale(3).reverse()
    }


    function resetDataModel(action){
        setDataModal();
    }

    function setDataModal(name = "", title = "", img = "", desc = "", id= ""){
        modalText.innerText = name;
        modalImg.src= img;
        modalTitle.innerHTML = title;
        modalDescription.innerHTML = desc;
        modal.dataset.id = id
    }

    teamMembers.forEach(
        function (teamMember) {
            teamMember.addEventListener("click", function(e){
                e.preventDefault();
                htmlOverflowManager("hidden");
                resetDataModel();
                setDataModal(teamMember.dataset.name, teamMember.dataset.title, teamMember.dataset.img, teamMember.dataset.extendeddesc, teamMember.dataset.id)
                let teammemberId = teamMembersArr.findIndex(x => x.dataset.id === teamMember.dataset.id)
                determineDisabledButtons(teammemberId)
                playOpenModalContainer().then(populateMemberDataInModal)
                function populateMemberDataInModal(){
                    playTimeline();
                }
            })
        }
    );


    function determineDisabledButtons(id){
        (id === 0) ? modalPrev.classList.add('disabled') : modalPrev.classList.remove('disabled');
        (id === teamMembersArr.length - 1) ? modalNext.classList.add('disabled') : modalNext.classList.remove('disabled');
    }

    function loopThroughMembers(action){
        // finding the index of the team member within the array of all team members
        // by matching the data modal ID (that is set when initializing the page)
        // with the id of the team member in the array
        let teammemberId = teamMembersArr.findIndex(x => x.dataset.id === modal.dataset.id)
        // selecting the next or previous team member based on the action needed
        let teamMemberSelected = teamMembersArr[(action === "prev") ? teammemberId - 1 : teammemberId + 1]
        // finding the index again of the team member within the array after selection
        let teamMemberSelectedId = teamMembersArr.findIndex(x => x.dataset.id === teamMemberSelected.dataset.id)
        
        determineDisabledButtons(teamMemberSelectedId)
        reverseTimeline().then(startNewMember)
        function startNewMember(){
            setDataModal(teamMemberSelected.dataset.name, teamMemberSelected.dataset.title, teamMemberSelected.dataset.img, teamMemberSelected.dataset.extendeddesc, teamMemberSelected.dataset.id)
            playTimeline()
        }
        // timelineFunction().then().then(a7a);
    }
    modalNext.addEventListener("click", function(e){
        loopThroughMembers("next");
    })
    modalPrev.addEventListener("click", function(e){
        loopThroughMembers("prev");
    })

    modalClose.addEventListener("click", function(e){
        e.preventDefault();
        reverseTimeline().then(reverseOpenModalContainer).then(() => resetDataModel("stop")).then(() => htmlOverflowManager("auto"))
    })
}